import { render, staticRenderFns } from "./User-photo.vue?vue&type=template&id=b839da84&scoped=true&"
import script from "./User-photo.vue?vue&type=script&lang=js&"
export * from "./User-photo.vue?vue&type=script&lang=js&"
import style0 from "./User-photo.vue?vue&type=style&index=0&id=b839da84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b839da84",
  null
  
)

export default component.exports